import { render } from "./ModalDeleteAndReason.vue?vue&type=template&id=2b19efdb&ts=true"
import script from "./ModalDeleteAndReason.vue?vue&type=script&lang=ts"
export * from "./ModalDeleteAndReason.vue?vue&type=script&lang=ts"

import "./ModalDeleteAndReason.vue?vue&type=style&index=0&id=2b19efdb&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__